<template>
  <v-navigation-drawer 
        v-model="drawerStatus" 
        app 
        dark 
        dense 
        class="blue-grey darken-4"
    >
      <v-list 
        nav 
        class="text-left"
        >
          <v-list-item 
            class="text-center my-4"
            >
              <v-list-item-title>
                  <v-list-item-action-text 
                    class="text-h5 font-weight white--text"
                    >
                      Nuclear Source DB
                  </v-list-item-action-text>
              </v-list-item-title>
          </v-list-item>
          <template 
            v-for="item in items"
            >
              <v-list-group 
                :key="item.text" 
                v-if="item.children && !item.disabled" 
                no-action 
                active-class="white--text"
                :disabled="item.disabled"
                >
                  <template v-slot:activator>
                    <v-list-item-icon>
                        <v-icon>
                            {{item.icon}}
                        </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        {{item.text}}
                    </v-list-item-title>
                  </template>
                  
                  <v-list-item 
                    v-for="(child, j) in item.children"
                    v-bind:key="j"
                    :to="child.route"
                    active-class="white--text"
                    :disabled="child.disabled"
                    >
                        <v-list-item-content>
                            <v-list-item-title>
                                {{child.text}}
                            </v-list-item-title>
                        </v-list-item-content>
                  </v-list-item>
              </v-list-group>

              <v-list-item 
                :key="item.text" 
                v-else 
                :to="item.route"
                :disabled="item.disabled"
                >
                    <v-list-item-icon>
                        <v-icon medium>
                            {{item.icon}}
                        </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{item.text}}
                        </v-list-item-title>
                    </v-list-item-content>
              </v-list-item>
          </template>
      </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex'

export default {
 Name:'AppDrawer',
 data:function(){
    return {
        isDisabled:false,
        items:[
             {
                text: 'Home',
                route: '/home',
                icon: 'mdi-home',
                disabled: false
             },
             {
                 text: 'Source',
                 icon: 'mdi-radioactive',
                 disabled: false,
                 children:[
                     {
                         text: 'Source List',
                         route: '/radiation/radiationlist',
                         icon: 'mdi-notebook',
                         disabled: false
                     },
                     {
                        text: 'New Source Entry',
                        route: '/radiation/newradiation',
                        icon: 'mdi-clipboard-list',
                        disabled: this.isDisabled
                    },
                    {
                        text:'Source Contact List',
                        route: '/radiation/globalupdate',
                        disabled: this.isDisabled
                    }
                 ]
             },
             {
                 text: 'Reports',
                 icon: 'mdi-notebook',
                 disabled: false,
                 children:[
                     {
                         text:'Radiation Report',
                         route: '/reports/radiation',
                         icon: 'mdi-notebook',
                         disabled: false
                     },
                     {
                         text:'Disposal Report',
                         route: '/reports/disposalreport',
                         icon: 'mdi-notebook',
                         disabled: false
                     },
                     {
                         text: 'Shutter Check',
                         route:'/reports/radiationshutterchecklist',
                         icon: 'mdi-clipboard-list',
                         disabled: false
                     },
                     {
                         text: 'Leak Test Report',
                         route: '/reports/leaktestreport',
                         icon: 'mdi-notebook',
                         disabled: false
                     }
                 ]
             },
             {
                 text:'Admin',
                 icon:'mdi-account-cog',
                 disabled: this.isDisabled,
                 children:[
                     {
                        text:'Admin Section',
                        route: '/admin/adminsection',
                        disabled: this.isDisabled
                     },
                     {
                        text:'Add New User',
                        route:'/users/newuser',
                        disabled: this.isDisabled
                     }
                 ]
             }
         ]
    }
 },
 computed:{
     ...mapState(['drawer']),
     drawerStatus:{
         get(){
             return this.drawer;
         },
         set(newStatus){
            return newStatus;
         }
     }
},

mounted:function(){
    
    let foundIndex=this.$msal.data.user.idToken.roles.indexOf('radiation-admin-role');     
    if(foundIndex!==-1)
    {
        console.log('Is admin: ');
        this.isDisabled=false;        
    }
    else
    {
        console.log('Is not admin: ');
        this.isDisabled=true;
    }

    this.items.map((menu)=>{
        if(menu.text==='Admin')
        {
            menu.disabled=this.isDisabled;
        }
        if(menu.children!==undefined)
        {
            
            menu.children.map((subMenu)=>{
            if(subMenu.route==='/radiation/newradiation' ||
                subMenu.route==='/radiation/globalupdate' )
            {
                subMenu.disabled=this.isDisabled;
            }
        
        });
        }
        
    });
 }
}
</script>

<style scoped>
</style>